module.exports = __webpack_public_path__ + "img/low-fat-zucchini-bread.a0a7a2be.jpg";